<template>
  <div class="dim" id="pop-policy1" style="display: block">
    <div class="popup-policy">
      <h2>
        {{ $ConstCode.labelTermsType(data.type) }}
        <button class="btn-x" @click="fnClose">x버튼</button>
      </h2>
      <section class="inner">
        <div class="txt-pop-guide">
          탈퇴한 아이디로는 다시 가입할 수 없으며, <br /><span
            >아이디 및 데이터는 복구할 수 없으므로</span
          >
          회원탈퇴 시 신중히 진행해 주시길 부탁드립니다.
        </div>
        <div class="info-box-popup" v-html="data.contents"></div>
      </section>
      <section class="btn-area">
        <button @click="fnCallBack">탈퇴하기</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-alert-withdraw',
  props: {
    index: {
      type: [Number],
      default: 0
    },
    layout: {
      type: [Object],
      default: () => {}
    },
    data: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      default: () => {}
    }
  },
  setup(props, context) {
    const fnClose = () => {
      context.emit('close', props.index)
    }
    const fnCallBack = (event) => {
      props.callBack(event)
    }
    return { fnClose, fnCallBack }
  }
}
</script>

<style scoped></style>
